import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { AccueilComponent } from './pages/accueil/accueil.component';
import { DocumentsComponent } from './pages/documents/documents.component';
import { AlbumsComponent } from './pages/Albums/Album.component';
import { AlbumDetailsComponent } from './pages/photos/album-details.component';
import { ObservationComponent } from './pages/observation/observation.component';
import { CahierDeTextComponent } from './pages/cahier-de-text/cahier-de-text.component';
import { CarnetComponent } from './pages/carnet/carnet.component';
import { DisciplineComponent } from './pages/discipline/discipline.component';
import { MessagerieComponent } from './pages/messagerie/messagerie.component';
import { EmploiComponent } from './pages/emploi/emploi.component';
import { ContineComponent } from './pages/contine/contine.component';
import { EventComponent } from './pages/event/event.component';
import { NoteComponent } from './pages/note/note.component';
import { PaiementComponent } from './pages/paiement/paiement.component';
import { AvisComponent } from './pages/avis/avis.component';
import { KissatiComponent } from './pages/kissati/kissati.component';
import { ConseilDeliceComponent } from './pages/conseil-delice/conseil-delice.component';
import { InfoenfantComponent } from './pages/infoenfant/infoenfant.component';
import { ContactComponent } from './pages/contact/contact.component';
import { authGuard } from './guards/auth.guard';
import { RdvparentalComponent } from './pages/rdvparental/rdvparental.component';
import { IsalniComponent } from './pages/isalni/isalni.component';
import { EClassComponent } from './pages/e-class/e-class.component';
import { Rafi9niComponent } from './pages/rafi9ni/rafi9ni.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'home', component: HomeComponent },
  { path: 'accueil', component: AccueilComponent, canActivate: [authGuard] },
  { path: 'e-class', component: EClassComponent, canActivate: [authGuard] },
  {
    path: 'documents',
    component: DocumentsComponent,
    canActivate: [authGuard],
  },
  { path: 'albums', component: AlbumsComponent, canActivate: [authGuard] },
  {
    path: 'cahierdetext',
    component: CahierDeTextComponent,
    canActivate: [authGuard],
  },
  {
    path: 'observation',
    component: ObservationComponent,
    canActivate: [authGuard],
  },
  {
    path: 'rdvparental',
    component: RdvparentalComponent,
    canActivate: [authGuard],
  },
  {
    path: 'album-details/:token',
    component: AlbumDetailsComponent,
    canActivate: [authGuard],
  },
  { path: 'carnet', component: CarnetComponent, canActivate: [authGuard] },
  {
    path: 'discipline',
    component: DisciplineComponent,
    canActivate: [authGuard],
  },
  { path: 'emploi', component: EmploiComponent, canActivate: [authGuard] },
  {
    path: 'messagerie',
    component: MessagerieComponent,
    canActivate: [authGuard],
  },
  { path: 'avis', component: AvisComponent, canActivate: [authGuard] },
  {
    path: 'conseilDelice',
    component: ConseilDeliceComponent,
    canActivate: [authGuard],
  },
  { path: 'kissati', component: KissatiComponent, canActivate: [authGuard] },
  { path: 'contine', component: ContineComponent, canActivate: [authGuard] },
  { path: 'event', component: EventComponent, canActivate: [authGuard] },
  { path: 'note', component: NoteComponent, canActivate: [authGuard] },
  { path: 'paiement', component: PaiementComponent, canActivate: [authGuard] },
  { path: 'isalni', component: IsalniComponent, canActivate: [authGuard] },
  { path: 'rafi9ni', component: Rafi9niComponent, canActivate: [authGuard] },
  {
    path: 'infoenfant',
    component: InfoenfantComponent,
    canActivate: [authGuard],
  },
  { path: 'contact', component: ContactComponent},
  { path: '**', redirectTo: '' },
];

